<template>
  <mi-btn
    flat
    icon="arrow-left"
    class="back-to-search__label"
    @click="handleBackToSearch"
  >
    <span class="back-to-search__text">
      {{ backToSearchText }}
    </span>
  </mi-btn>
</template>

<script>
  export default {
    name: 'SavedTablesBackToSearch',
    props: {
      backToSearchText: {
        type: String,
        required: false,
        default: 'Back to search'
      },
      altText: {
        type: String,
        required: false,
        default: 'Return to variant management search'
      }
    },
    emits: ['on-back-to-search-click'],
    setup(props, { emit }) {
      const handleBackToSearch = () => {
        emit('on-back-to-search-click')
      }
      return { handleBackToSearch }
    }
  }
</script>

<style lang="scss">
  // stylelint-disable declaration-no-important
  .back-to-search {
    &__label {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;

      .q-focus-helper {
        display: none !important;
      }
    }

    &__label.mi-btn.q-btn.q-btn--flat:hover {
      background-color: transparent !important;
      color: $mi-anthracite-800 !important;
    }

    &__text {
      color: $mi-anthracite-800;
      text-transform: uppercase;
      font-size: $mi-field-font-size;
      cursor: pointer;
    }
  }
</style>
